// --- AuthUIController.ts ---
import { Auth0ClientInstance } from "./Auth0ClientInstance";
import { AuthState } from "./AuthState";
export class AuthUIController {
    static async sync() {
        const isAuthenticated = await Auth0ClientInstance.isAuthenticated();
        isAuthenticated ? AuthState.login() : AuthState.logout();
        this.updateUI(isAuthenticated);
    }
    static updateUI(isAuthenticated) {
        // update all [data-mg2-action] elements on the page including inside rendered templates
        document.querySelectorAll('[data-mg2-action="login"]').forEach(el => {
            el.style.display = isAuthenticated ? "none" : "";
        });
        document.querySelectorAll('[data-mg2-action="register"]').forEach(el => {
            el.style.display = isAuthenticated ? "none" : "";
        });
        document.querySelectorAll('[data-mg2-action="logout"]').forEach(el => {
            el.style.display = isAuthenticated ? "" : "none";
        });
        document.querySelectorAll('[data-mg2-action="click"]').forEach(el => {
            el.style.display = isAuthenticated ? "" : ""; // always visible — subscribe/activate buttons
        });
    }
}
